import React, { lazy, Suspense } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { RoutePermissionGuard } from '@shared/auth/RoutePermissionGuard';
import { Role } from '@shared/auth/AuthContext';

const ExecutiveDashboardPage = lazy(() => import('./modules/executive/pages/ExecutiveDashboardPage'));
const UserAnalyticsPage = lazy(() => import('./modules/telemetry/pages/UserAnalyticsPage'));
const WebsiteAnalyticsPage = lazy(() => import('./modules/telemetry/pages/WebsiteAnalyticsPage'));
const ReportBuilderPage = lazy(() => import('./modules/reports/pages/ReportBuilderPage'));
const FunnelPage = lazy(() => import('./modules/executive/pages/FunnelPage'));
const AttendanceTrendsPage = lazy(() => import('./modules/executive/pages/AttendanceTrendsPage'));

const LoadingFallback: React.FC = () => (
  <div className="flex h-64 items-center justify-center">
    <div className="h-6 w-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
  </div>
);

const BI_READ_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'accountant'];
const REPORT_ROLES: Role[] = ['owner', 'admin', 'branch_head', 'accountant'];

export const biRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="executive" replace />,
  },
  {
    path: 'executive',
    handle: { crumb: 'Executive Command Center' },
    element: (
      <RoutePermissionGuard permission="bi.read" allowedRoles={BI_READ_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <ExecutiveDashboardPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'user-analytics',
    handle: { crumb: 'Student Learning Analytics' },
    element: (
      <RoutePermissionGuard permission="bi.read" allowedRoles={BI_READ_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <UserAnalyticsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'traffic',
    handle: { crumb: 'Website & Ad Traffic' },
    element: (
      <RoutePermissionGuard permission="bi.read" allowedRoles={BI_READ_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <WebsiteAnalyticsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'report-builder',
    handle: { crumb: 'Dynamic SQL Builder' },
    element: (
      <RoutePermissionGuard permission="reports.run" allowedRoles={REPORT_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <ReportBuilderPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'funnel',
    handle: { crumb: 'Admissions Funnel' },
    element: (
      <RoutePermissionGuard permission="bi.read" allowedRoles={BI_READ_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <FunnelPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
  {
    path: 'attendance',
    handle: { crumb: 'Attendance Heatmaps' },
    element: (
      <RoutePermissionGuard permission="bi.read" allowedRoles={BI_READ_ROLES}>
        <Suspense fallback={<LoadingFallback />}>
          <AttendanceTrendsPage />
        </Suspense>
      </RoutePermissionGuard>
    ),
  },
];

export default biRoutes;
